/** 30 minutes — RGS-style idle session policy (matches launcher integration expectations). */
export const GAME_IDLE_RELOAD_MS = 30 * 60 * 1000;

/**
 * After `idleMs` without pointer / key / wheel input, invoke `onIdle` once.
 * When the tab becomes visible again, the idle timer is restarted (same as checken-game).
 * @param {{ idleMs?: number, onIdle: () => void }} opts
 * @returns {() => void} dispose
 */
export function installGameIdleReload({ idleMs = GAME_IDLE_RELOAD_MS, onIdle } = {}) {
  if (typeof window === 'undefined') return () => {};

  let timer = null;
  const clearTimer = () => {
    if (timer != null) {
      clearTimeout(timer);
      timer = null;
    }
  };

  const fire = () => {
    clearTimer();
    onIdle?.();
  };

  const arm = () => {
    clearTimer();
    timer = setTimeout(fire, idleMs);
  };

  const bump = () => {
    arm();
  };

  arm();

  window.addEventListener('pointerdown', bump, { capture: true });
  window.addEventListener('keydown', bump, { capture: true });
  window.addEventListener('wheel', bump, { passive: true, capture: true });

  const onVis = () => {
    if (document.visibilityState === 'visible') bump();
  };
  document.addEventListener('visibilitychange', onVis);

  return () => {
    clearTimer();
    window.removeEventListener('pointerdown', bump, { capture: true });
    window.removeEventListener('keydown', bump, { capture: true });
    window.removeEventListener('wheel', bump, { capture: true });
    document.removeEventListener('visibilitychange', onVis);
  };
}
